import { render } from "./vuser.vue?vue&type=template&id=5214f234&scoped=true"
import script from "./vuser.vue?vue&type=script&lang=js"
export * from "./vuser.vue?vue&type=script&lang=js"

import "./vuser.vue?vue&type=style&index=0&id=5214f234&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5214f234"]])

export default __exports__